{
  "app.title": "Tickbird · Ticket workspace",
  "app.description": "Tickbird ticket workspace",
  "language.switch": "Change language",
  "fallback.http.badRequest": "The request is invalid.",
  "fallback.http.unauthorized": "Your session has expired. Please sign in again.",
  "fallback.http.forbidden": "You do not have permission to access this resource.",
  "fallback.http.notFound": "The requested resource was not found.",
  "fallback.http.requestTimeout": "The request timed out. Please try again.",
  "fallback.http.networkError": "Unable to connect. Check your network and try again.",
  "fallback.http.internalServerError": "Something went wrong on the server. Please try again later.",
  "fallback.http.requestFailed": "Request failed ({status})",
  "fallback.http.messageWithDetails": "{message}: {details}",
  "fallback.oauth.authenticationFailed": "Authentication failed. Sign in again and retry."
}
